import React from "react";
import "antd/dist/antd.css";
import { Button, notification } from "antd";
import Amplify, { Auth, Storage } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import { Row } from "antd";
import { Form, Icon, Input, Modal, message } from "antd";
import { ArrowRightOutlined, UserOutlined } from "@ant-design/icons";
import newLogo from "../Images/newLogo.JPG";
import { withAppContext } from "../store/contextStore";
import { getUserProfile } from "../api/userProfile";
import { getDetails, update } from "../api/Apis";
import { getCustomerOrCarrierDetails } from "../api/OraganizationApis";
import AppConfigs from "../Config/AppConfig";
import awsConfigure from "../Config/AwsConfig";
import NumberFormat from "react-number-format";

Amplify.configure(awsConfigure);

class Login extends React.Component {
  state = {
    errors: "",
    visible: false,
    loading: false,
    showModal: false,
    codeData: "",
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
    console.log("closed");
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    console.log("closed");
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.doLogin(false);
      }
    });
  };

  doLogin = async (needUserStatusUpdate) => {
    let lowerEmail = this.props.form.getFieldValue("username");
    try {
      this.setState({
        loading: true,
      });
      const user = await Auth.signIn(
        lowerEmail,
        this.props.form.getFieldValue("password")
      );
      console.log("+++", user);
      // if (!user.attributes.email_verified) {
      //   this.setState({
      //     showModal: true,
      //     loading: false,
      //   });
      // } else {
        const userDetails = Object.assign(
          {},
          {
            token: user.signInUserSession.idToken.jwtToken,
            userid: user.username,
          }
        );
        if (needUserStatusUpdate) {
          let data = {
            entityData: {
              isActive: true,
            },
          };
          update(
            AppConfigs["entityNames"]["users"],
            userDetails.userid,
            data
          ).then((result) => {
            if (result.success) {
              this.setState({
                showModal: false,
              });
              console.log("Success");
            } else {
              console.log(result.errors);
            }
          });
        }
        this.setState({
          loading: false,
        });
        this.props.context.setUser(userDetails, false);
        this.getProfile(userDetails.userid);
      // }
      // this.getProfile(userDetails.userid);
      // this.props.history.push('/carrier_app/orders');
    } catch (err) {
      if (err.code === "UserNotConfirmedException") {
        this.setState({
          showModal: true,
          loading: false,
        });
      } else if (err.code === "PasswordResetRequiredException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "NotAuthorizedException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "UserNotFoundException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else {
        this.setState({
          loading: false,
          errors: err.message,
        });
      }
    }
  };

  getProfile = (id) => {
    this.setState({
      loading: true,
    });
    getUserProfile(id).then(async (result) => {
      if (result.success) {
        this.setState({
          loading: false,
        });
        let userData = result.data;
        if (userData["profilePic"]) {
          userData["profilePicPath"] = await Storage.get(
            userData["profilePic"]
          );
        }
        localStorage.setItem("orgId", result.data.orgId);
        localStorage.setItem("userDetails", JSON.stringify(userData));
        this.props.context.setUserDetails(userData);
        if (result.data.userProfile === "S") {
          this.props.history.push("/app/oraganizations");
        } else if (
          result.data.userProfile === "A" ||
          result.data.userProfile === "M"
        ) {
          getDetails(
            AppConfigs["entityNames"]["organizations"],
            result.data.orgId
          ).then((result) => {
            if (result.success) {
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              this.props.history.push("/app/loads");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        } else if (
          result.data.userProfile === "CA" ||
          result.data.userProfile === "SCA"
        ) {
          if (result.data.userProfile === "SCA") {
            getCustomerOrCarrierDetails(userData.orgId).then((result) => {
              if (result.success) {
                localStorage.setItem("orgDetails", JSON.stringify(result.data));
                this.props.history.push("/carrier_app/allOrders");
              } else {
                this.setState({
                  loading: false,
                  errors: result.errors,
                });
              }
            });
          } else {
            userData.carrierDetails.id &&
              getCustomerOrCarrierDetails(userData.carrierDetails.id).then(
                (result) => {
                  if (result.success) {
                    localStorage.setItem(
                      "orgDetails",
                      JSON.stringify(result.data)
                    );
                    this.props.history.push("/carrier_app/allOrders");
                  } else {
                    this.setState({
                      loading: false,
                      errors: result.errors,
                    });
                  }
                }
              );
          }
        } else if (
          result.data.userProfile === "CU" ||
          result.data.userProfile === "SCU"
        ) {
          if (result.data.userProfile === "SCU") {
            getCustomerOrCarrierDetails(userData.orgId).then((result) => {
              if (result.success) {
                localStorage.setItem("orgDetails", JSON.stringify(result.data));
                this.props.history.push("/app/stones");
              } else {
                this.setState({
                  loading: false,
                  errors: result.errors,
                });
              }
            });
          } else {
            userData?.carrierDetails?.id &&
              getCustomerOrCarrierDetails(userData.carrierDetails.id).then(
                (result) => {
                  if (result.success) {
                    localStorage.setItem(
                      "orgDetails",
                      JSON.stringify(result.data)
                    );
                    // this.props.context.setOrgDetails(result.data);
                    this.props.history.push("/app/stones");
                  } else {
                    this.setState({
                      loading: false,
                      errors: result.errors,
                    });
                  }
                }
              );
          }
        } else if (result.data.userProfile === "D") {
          getDetails(
            AppConfigs["entityNames"]["organizations"],
            result.data.orgId
          ).then((result) => {
            if (result.success) {
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              this.props.history.push("/app/driver/todo");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          loading: false,
          errors: result.errors.toString(),
        });
      }
    });
  };

  confirmUser = async () => {
    this.setState({
      loading: true,
    });
    let lowerEmail = this.props.form.getFieldValue("username");
    try {
      await Auth.confirmSignUp(lowerEmail, this.state.codeData).then(
        async (result) => {
          if (result === "SUCCESS") {
            await this.doLogin(true);
          }
        }
      );
    } catch (error) {
      this.setState({
        loading: false,
      });
      message.error("Invalid Confirm Code");
    }
  };
  handleResendConfirmCode = async () => {
    let lowerEmail = this.props.form.getFieldValue("username").toLowerCase();
    try {
      await Auth.resendSignUp(lowerEmail);
      notification["success"]({
        message: "code resent successfully",
      });
    } catch (err) {
      console.log("error resending code: ", err);
      notification["error"]({
        message: "error resending code.",
      });
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div
        style={{ background: "#0E4D90 0% 0% no-repeat padding-box" }}
        className="admin-login-form"
      >
        {/* <div style={{ width: "550px" }}>
          <Row>
            <Col span={6}>
              <img src={newLogo}  alt="Logo" style={{width: '100%'}}/>
            </Col>
            <Col span={18} style={{ marginTop: "30px" }}>
              <span style={{ color: "#FFFFFF" }}>Bulk Material Pro </span>
            </Col>
          </Row>
        </div> */}
        <div className="login-fields">
          <Form onSubmit={this.handleSubmit}>
            <Row>
              {/* <h2 className="Login" style={{ textAlign: "center" }}>Login</h2> */}
              <div style={{ textAlign: "center" }}>
                <img src={newLogo} alt="Logo" style={{ width: "50%" }} />
              </div>
            </Row>
            <Form.Item>
              {getFieldDecorator("username", {
                rules: [
                  {
                    required: true,
                    message: "Please input your Email Address!",
                  },
                ],
              })(
                <Row>
                  <span
                    style={{
                      marginBottom: "-40px",
                      position: "absolute",
                      zIndex: 1,
                    }}
                  >
                    <UserOutlined
                      style={{
                        color: "rgba(0,0,0,.25)",
                        margin: "10px",
                      }}
                    />
                  </span>
                  <Input
                    type="email"
                    placeholder="Email Address"
                    style={{
                      // textTransform: "lowercase",
                      height: "40px",
                      paddingLeft: "30px",
                    }}
                  />
                </Row>
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator("password", {
                rules: [
                  { required: true, message: "Please input your Password!" },
                ],
              })(
                <Input.Password
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Password"
                  style={{ height: "40px" }}
                />
              )}
            </Form.Item>
            {
              this.state.errors && (
                <div style={{ textAlign: "center" }}>
                  <span style={{ color: "#f5222d" }}>{this.state.errors}</span>
                </div>
              )
              //  <Alert
              //    message={ this.state.errors }
              //    description='Error Logging in.'
              //    type='error'
              //    showIcon
              //  />
            }
            <Form.Item className="password-row">
              {/* <a className="login-form-forgot" href="">Forgot password?</a> */}
              <Link to="/forgotPassword">Forgot password?</Link>
              {/* <Button
                htmlType='submit'
                loading={ this.state.loading }
              >
                <span className='login-now'>LOGIN NOW</span>
              </Button> */}
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.loading}
                className="login-form-button"
              >
                Login
              </Button>
            </Form.Item>
            <Form.Item className="password-row">
              <Link
                to="customersignup"
                style={{ float: "left", fontWeight: "bold", fontSize: "16px" }}
              >
                <span className="login-custom"> Customer Registration</span>
              </Link>
              <Link
                to="carrier_login/Signup"
                style={{ float: "right", fontWeight: "bold", fontSize: "16px" }}
              >
                <span className="login-custom"> Carrier Registration</span>
              </Link>
            </Form.Item>
            {/* <Form.Item className="password-row" style={{ textAlign: "center" }}>
              <Link
                to="driverSignUp"
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                {/* <Button
                  className="ant-input"
                  style={{ background: "#0E4D90", color: "white" }}
                > */}
            {/* <span style={{ marginRight: "5px" }}>Driver Registration</span>
                <ArrowRightOutlined /> */}
            {/* </Button> */}
            {/* </Link>
            </Form.Item> */}
          </Form>
        </div>

        <Modal
          visible={this.state.showModal}
          title={
            <p
              className="font-family-style font-medium-size"
              style={{ color: "blue", margin: "0px" }}
            >
              Confirm SignUp
            </p>
          }
          onCancel={() => {
            this.setState({ showModal: false, codeData: "" });
          }}
          maskClosable={false}
          className="modal-black-close"
          footer={false}
        >
          <div style={{ padding: "5px 10px" }}>
            <span className="font-family-style text-size padding register-confirm">
              We have sent you a confirmation code to your email. Please enter
              the code below to complete your signup. Thank you.
            </span>
          </div>
          <Form
            className="padding font-family-style text-size"
            style={{ padding: "5px 10px" }}
          >
            <NumberFormat
              className="ant-input-number"
              placeholder="Please input the code."
              maxLength="6"
              onChange={(e) => {
                this.setState({ codeData: e.target.value });
              }}
              value={this.state.codeData ? this.state.codeData : ""}
              style={{
                height: "40px",
                marginBottom: "1vw",
                width: "100%",
                padding: "5px 10px",
              }}
            />
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                onClick={this.confirmUser}
                loading={this.state.loading}
                style={{ height: "40px" }}
              >
                <span className="align">Submit</span>
              </Button>
              {/* <Button
                type="primary"
                htmlType="reset"
                onClick={() => {
                  this.setState({ showModal: false, codeData: "" });
                }}
                style={{
                  height: "40px",
                  marginLeft: "1vw",
                }}
              >
                <span className="align">Cancel</span>
              </Button> */}
              <Button
                type="primary"
                htmlType="reset"
                onClick={this.handleResendConfirmCode}
                style={{
                  height: "40px",
                  marginLeft: "1vw",
                  background: "#ff6c5e",
                  border: "1px solid #ff6c5e",
                }}
              >
                <span className="align">Resend</span>
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}
const WrappedNormalLoginForm = Form.create({ name: "Login" })(
  withAppContext(withRouter(Login))
);

export default WrappedNormalLoginForm;
